<template>
  <div class="appTable">
    <div class="appTable__info">
      <AppPageHeader></AppPageHeader>
    </div>
    <div class="appTable__tool">
      <div class="appTable__tool__left">
        <el-button-group>
          <el-button
            type="primary"
            icon="el-icon-refresh"
            title="刷新"
            class="refreshBtnClass"
            @click="DoRefresh"
            :class="{'rotation_ani' : isRefreshing}"
          ></el-button>
          <el-button
            type="info"
            icon="el-icon-sunrise"
            title="回到默认"
            class="refreshBtnClass"
            @click="DoInit"
          ></el-button>
        </el-button-group>

        <!-- slot : tools -->
        <slot name="tools"></slot>
      </div>
      <div class="appTable__tool__right">
        <el-button
          type="primary"
          :icon="isFilter? 'el-icon-receiving' : 'el-icon-files'"
          :title="isFilter? '收起筛选选项' : '更多筛选选项'"
          @click="doFilter"
        ></el-button>
        <el-input v-model="searchword" placeholder="快速搜索内容" @change="onSWChanged">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
    </div>
    <el-collapse-transition>
      <div class="appTable_tool_filter" v-show="isFilter">
        <slot name="filter"></slot>
      </div>
    </el-collapse-transition>
    <div class="appTable__tool__fixed">
      <slot name="fixedFilter"></slot>
    </div>

    <!-- 默认的Table控件 -->
    <el-table
      :data="datas"
      stripe
      border
      class="appTable__datas"
      header-row-class-name="table-header-row"
      v-loading="loadingTable"
    >
      <template v-if="expand">
        <el-table-column type="expand">
          <template slot-scope="props">
            <slot name="expand" :props="props"></slot>
          </template>
        </el-table-column>
      </template>

      <template v-for="item in columns">
        <template v-if="item.scope">
          <el-table-column :label="item.label" :key="item.prop" :width="item.width">
            <template slot-scope="scope">
              <slot name="columnSlotFirst" :props="scope"></slot>
            </template>
          </el-table-column>
        </template>
        <template v-if="!item.scope">
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            :key="item.prop"
            :width="item.width"
          ></el-table-column>
        </template>

        <template v-if="item.isStatus">
          <template slot-scope="scope">
            <p
              :class="getTableStatusClass(scope.row.status)"
              :key="item.prop"
            >{{scope.row.statusStr}}</p>
          </template>
        </template>
      </template>
      <el-table-column fixed="right" label="操作" class-name="column__tool">
        <template slot-scope="scope">
          <template>
            <router-link
              v-if="fromWhere=='userClassHours'"
              :to="{path:baseUrl + '/classHoursDetail',query:{id:scope.row.id}}"
              target="_blank"
            >
              <el-button
                type="primary"
                size="mini"
                v-if="scope.row.status !=2"
                plain
                class="column__tool__buttom"
              >查看详情&nbsp;</el-button>
            </router-link>
            <router-link
              v-if="fromWhere=='studyclassHours'"
              :to="{path:baseUrl + '/studyclassHours/studyclassHoursDetail',query:{id:scope.row.id}}"
              target="_blank"
            >
              <el-button
                type="primary"
                size="mini"
                v-if="scope.row.status !=2"
                plain
                class="column__tool__buttom"
              >查看详情&nbsp;</el-button>
            </router-link>
          </template>
          <slot name="columnSlotTool" :props="scope.row.id"></slot>
        </template>
      </el-table-column>
    </el-table>

    <div class="appTable__footer">
      <div class="appTable__footer_page">
        <el-pagination
          :pager-count="5"
          class="el-pag"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page_size"
          layout="sizes,total,next, pager,prev,jumper "
          :total="total"
        ></el-pagination>
      </div>
      <div class="appTable__footer__info">
        <p>
          <i class="el-icon-info"></i>
          <slot name="table__footer__info"></slot>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { BaseVue } from "../../mixin/index";
import { getListApi } from "@/api/core/table/table";
import { getPageData,cachePage,cacheSize,cachePageData} from "@/utils/tablestorage";

export default {
  name: "HoursTableContainer",
  
  mixins: [BaseVue],
  
  components: {
    // 组件注册
  },
  
  props: {
    // api 默认地址
    serverUrl: {
      type: String,
      required: false
    },
    // 表格列配置
    columns: {
      type: Array,
      required: false
    },
    // 是否使用默认排序
    FilterStatusDefault: {
      type: Boolean,
      default: true
    },
    // 表单首选项是否打开
    expand: {
      type: Boolean,
      default: false
    },
    // baseurl
    baseUrl: {
      type: String,
      default: ""
    },
    // 显示审核的选项
    showReviewOption: {
      type: Boolean,
      default: false
    },
    // 改变查看详情路径
    fromWhere: {
      type: String,
      default: ""
    }
  },
  
  data() {
    return {
      isFilter: true, // 是否展开更多筛选项
      isRefreshing: false,
      loadingTable: false, // 正在加载表单
      
      datas: [], // table 数据
      
      // filter params
      searchword: "", // 搜索关键字
      status: 0,
      
      // 外部传入的筛选值
      sid: "",
      pid: "",
      partyids: "",
      unitids: "",
      ccpid: -1,
      checkid: -1,
      
      dataMap: null, // 数据 map
      
      // 分页
      currentPage: 3,
      page_size: 10,
      total: 0
    };
  },
  
  methods: {
     async initTable() {
      console.log("START INIT TABLE")

      let pageData = getPageData(this.$route.name);
      console.log("init table 2",pageData.page,typeof pageData.page)
      this.page_size = pageData.size;


      let pageVal = pageData.page;


      // 包裹参数
      const serverUrl = this.serverUrl;
      const tableFilterData = {
        pid: this.pid,
        sid: this.sid,
        unitids: this.unitids,
        partyids: this.partyids,
        ccpid: this.ccpid,
        checkid: this.checkid,
        status: this.status,
        searchword: this.searchword,
        dataMap: this.dataMap
      };
      const start = (pageVal - 1) * this.page_size;
      const tablePageData = {
        start: start,
        size: this.page_size,
      };
      
      // this.loadingTable = true;
      
      let resp = await getListApi(serverUrl, tableFilterData, tablePageData);
      this.total = resp.totals;
      this.datas = resp.datas;
      // this.loadingTable = false;

      console.log("AFTER init data",pageVal,this.page_size)

      this.currentPage = pageVal;

      this.$forceUpdate();

    },
    
    DoInit() {
      // 恢复默认
      console.log("do init")
      this.page_size = 10;
      this.currentPage = 1;
      this.searchword = "";
      this.status = 0;
      this.initTable();
    },
    
    DoRefresh() {
      // 刷新
      if (!this.isRefreshing) {
        this.isRefreshing = true;
        
        this.initTable();
        
        setTimeout(() => {
          this.isRefreshing = false;
        }, 0.7 * 1000);
      }
    },
    
    doFilter() {
      this.isFilter = !this.isFilter;
    },
    

    // 状态选择框/所属学习班改动
    onTableFilterStatusDataChanged(value) {
      this.status = value;
    },
    
    // 外部筛选框输入
    updateSid(sid) {
      this.sid = sid;
      this.initTable();
    },
    
    updatePid(pid) {
      this.pid = pid;
      this.initTable();
    },
    
    updatePartyid(partyids) {
      this.partyids = partyids;
      this.initTable();
    },
    
    updateUnitid(unitid) {
      this.unitids = unitid;
      this.initTable();
    },
    
    updateCcpid(ccpid) {
      this.ccpid = ccpid;
      this.initTable();
    },
    
    updateCheckid(checkid) {
      this.checkid = checkid;
      this.initTable();
    },
    
    // 外部筛选框输入
    updateParams(pkey, pval) {
      if (!this.dataMap) {
        this.dataMap = new Map();
      }
      
      this.dataMap.set(pkey, pval);
      this.initTable();
    },
    

    onSWChanged(val){
      this.currentPage = 1
      this.initTable();
      console.log("SW CHANGED",val)
    },

    // 分页
    handleSizeChange(p) {
      this.page_size = p;
      this.currentPage = 1;
      cachePageData(this.$route.name,this.currentPage,this.page_size);
      this.initTable();
      console.log("handle size change",p)
    },
    
    handleCurrentChange(p) {
      this.currentPage = p;
      cachePageData(this.$route.name,this.currentPage,this.page_size);
      this.initTable();
      console.log("handle current change",p)
    },
    
    getTableStatusClass(status) {
      // 这个方法在基类中，如果需要可以在这里重写
      return "";
    }
  },
  
  
  async mounted() {
    console.log("mounted CLASS HOURS TABLE CONTAINER")
    await this.initTable();
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
